import React from 'react'

import { Button, ButtonProps } from '../../components/button/button.js'
import {
    OptionCardGroup,
    OptionCardGroupProps,
    OptionCardGroupValue,
} from '../../components/forms/option-card-group/option-card-group.js'
import { OptionCard, OptionCardProps } from '../../components/forms/option-card/option-card.js'
import { GridColumn } from '../../components/grid/grid-column.js'
import { Grid } from '../../components/grid/grid.js'
import { FlowTypes } from '../../types.js'

export interface FlowPickerProps {
    title: string
    optionCardGroupProps: OptionCardGroupProps
    flowOptions: OptionCardProps[]
    buttonProps: ButtonProps

    onSubmit(value: FlowTypes): void
}

const renderFlowPickerCard = (props: OptionCardProps) => {
    return (
        <OptionCard {...props} checked={true} type="simple" key={props.id}>
            <div className="option-card__mid text">
                <h2 className="text h4">{props.labelText}</h2>
            </div>
        </OptionCard>
    )
}

export const FlowPicker = (props: FlowPickerProps): JSX.Element => {
    const [selected, setSelected] = React.useState('')

    const optionSelect = (value: OptionCardGroupValue) => {
        setSelected('' + value)
    }

    return (
        <Grid>
            <GridColumn width={['xs-4', 'md-12']}>
                <div className="flow-picker text text-center">
                    <h2>{props.title}</h2>

                    <div
                        className="flow-picker__options text"
                        style={{ width: 'fit-content', marginLeft: 'auto', marginRight: 'auto' }}
                    >
                        <OptionCardGroup {...props.optionCardGroupProps} value={selected} onChange={optionSelect}>
                            {props.flowOptions.map((option) => {
                                return renderFlowPickerCard(option)
                            })}
                        </OptionCardGroup>
                    </div>

                    <Button
                        {...props.buttonProps}
                        isDisabled={!selected}
                        onClick={() => {
                            if (selected === 'existing-user') {
                                return props.onSubmit('existing-user')
                            }

                            return props.onSubmit('new-user')
                        }}
                    />
                </div>
            </GridColumn>
        </Grid>
    )
}
